import '../scss/styles.scss';
import scrollToSection from "./ScrollToSection"

export default function Services() {
    return (
        <section id="services" className="services">
            <div className="services-wrapper">
                <div className="services-text">
                    <h2>Our Services</h2>
                </div>
                <div className="services-categories">
                    <div className="category">
                        <h3>Audio & Visual Engineering</h3>
                        <li>
                            <h4>Speaking Engagements -</h4>
                            <p>Ranging from individual presenters to panel discussions.</p>
                        </li>
                        <li>
                            <h4>Corporate Events -</h4>
                            <p>Boardroom style meetings to large venue conferences.</p>
                        </li>
                        <li>
                            <h4>Video Conferencing -</h4>
                            <p>Video soundbar and support for soft codec meeting platforms such as Teams, WebEx, Zoom, etc...</p>
                        </li>
                        <li>
                            <h4>Weddings and Rehearsals -</h4>
                            <p>Sound production for your rehearsal dinner speeches and your custom after-party playlist.</p>
                        </li>
                        <li>
                            <h4>Live Music -</h4>
                            <p>Live sound engineering and equipment rentals.</p>
                        </li>
                        <li>
                            <h4>Outdoor Movies -</h4>
                            <p>Full audio / visual services for movies under the stars.</p>
                        </li>
                    </div>
                    <div className="category">
                        <h3>Information Technology</h3>
                        <li className="servicesImg"></li>
                        <li>
                            <p><span>Networking</span> - Home and Business</p>
                        </li>
                        <li>
                            <p><span>Audio Installation</span> - Home and Business</p>
                        </li>
                        <li>
                            <p><span>Video Installation</span> - Home and Business</p>
                        </li>
                    </div>
                    <div className="category">
                        <h3>Audio Equipment Rentals</h3>
                        <li className="servicesImg rentals"></li>
                        <p>Please inquire about our expanding list of <span>audio equipment rentals</span>, focusing on high quality PA systems, monitors, instruments, and backline equipment for bands.</p>
                        <div className="inquire-now-button">
						<a className="inquire-now-btn"
							href="#inquire"
							onClick={scrollToSection}>Inquire</a>
				    </div>
                    </div>
                </div>
            </div>
        </section>
    )
}